module.exports = __webpack_public_path__ + "static/media/phone.a60ba267.svg";